export const VERSION_STORAGE_KEY_PREFIX = 'echo_version_data'
export const VERSION_STORAGE_VALID_KEY_PREFIX = 'echo_version_valid'

export const ECHO_VERSION = 'ECHO_VERSION'
// 注册时，继续填写信息
export const REGISTER_CONTINUE_CODE = 20004
// 表示该值需要模糊
export const BLUR_VALUE = 'N/A'
export const BLUR_VALUE_2 = '***'
export const BLUR_CODE = 100004
export const BLUR_COVER = '888'

// 接口成功的业务状态码，
export const SUCCESS_CODE = 0

// 会员权限不足
export const UNAUTHORIZED_CODE = 50001
// 用户没有权限访问
export const PERMISSION_DENIED_CODE = 10007
// 多人登录错误码
export const MULTIPLE_LOGIN_CODE = 10011

export const TOKEN_COOKIE = 'token'
export const LANG_COOKIE = 'lang'
export const CURRENCY_COOKIE = 'currency'
export const REGION_COOKIE = 'region'
export const IS_FIRST_VISIT_COOKIE = 'is_first_visit'
export const USER_ID_COOKIE = 'user_id'

// COOKIE过期时间30天
export const COOKIE_EXPIRE_TIME = 60 * 60 * 24 * 30

export const GOOGLE_CLIENT_ID = '375243906986-3s8cn8072mu25h7su3lnp3m3uj0sjo46.apps.googleusercontent.com'

export const NOTIFY_ID = 'notify_id'

export const INVITE_CODE_STORAGE = 'invite_code'

export const SHOW_TRIAL_MODAL = 'show_trial_modal'

export const NOT_VERIFIED = 20001

// 配额不足
export const QUOTA_LACKING = 40001

// 店铺已被绑定其他账号
export const TIKTOK_SHOP_OCCUPIED_CODE = 30006
// 授权回调失败
export const TIKTOK_SHOP_FAILED_CODE = 30007
// 店铺未授权
export const TIKTOK_SHOP_UNAUTHORIZED_CODE = 30008
// 店铺授权过期
export const TIKTOK_SHOP_EXPIRED_CODE = 30009

// 首页直播banner
export const LIVE_URL = `https://d18sdvl5kwtzlk.cloudfront.net/misc/echotik-banner-1.webp`
// banner跳转链接
export const GO_URL = 'https://mp.weixin.qq.com/s/9P9gIi1YI3guloUJzTcKRQ'

export const REACT_APP_SITE_KEY = '6LftD-MoAAAAAPpJcFy7Os_TBJMZbRZtgFO4Sd2G'

export const LOCAL_USERINFO_KEY = 'userInfo'

// 绑定手机号提醒
export const PHONE_VERIFY_STORAGE_KEY = 'phone_verify_modal_key'

export const NEXT_PUBLIC_POSTHOG_KEY = 'phc_sYMtIBI4VtZqhAer3R1qAfXCIloFQXBy8DeLlEHSiOb'
export const NEXT_PUBLIC_POSTHOG_HOST = 'https://us.i.posthog.com'

export const TENCENT_APPID = '197160336'

// 续费弹窗提醒
export const RECHARGE_STORAGE_KEY = 'recharge_modal_key'
